module.exports = __webpack_public_path__ + "img/university_9.c26453f7.png";